// Выбор карточки для массовых действий — нажатием на её пустое место
// (плитки аккаунтов и объявлений). Кнопки, ссылки и поля внутри карточки
// работают как обычно; выделенный мышью текст выбором не считается.
const INTERACTIVE = "button, a, input, textarea, select, label, [role='button'], [role='menu'], [role='menuitem'], [data-no-card-select]";

// Открытые меню и списки закрываются нажатием мимо них, и это нажатие не
// должно заодно выбирать карточку под ним. Закрываются они уже на pointerdown,
// так что к click их нет — смотрим заранее, в фазе захвата.
const POPUPS = "[data-account-menu], .ui-select-menu, .profile-panel, [role='menu'], [role='listbox']";
let pressClosedPopup = false;
if (typeof document !== "undefined") {
  document.addEventListener("pointerdown", () => {
    pressClosedPopup = Boolean(document.querySelector(POPUPS));
  }, true);
}

export const isCardSelectClick = (event) => {
  const target = event?.target;
  if (!target || typeof target.closest !== "function") return false;
  // Клик в портале (меню карточки) всплывает по дереву React, а не по DOM.
  if (event.currentTarget && !event.currentTarget.contains(target)) return false;
  if (pressClosedPopup) return false;
  if (target.closest(INTERACTIVE)) return false;
  const selection = typeof window !== "undefined" && typeof window.getSelection === "function"
    ? window.getSelection()
    : null;
  return !(selection && String(selection).trim());
};
